import { PropsWithChildren } from 'react';

import styled from '@/styled';

interface IProps {
  className?: string;
  icon?: React.ReactNode;
  cover: string | React.ReactNode;
  size: string;
  onClick?: () => void;
}

const AdaptiveCard = (props: PropsWithChildren<IProps>) => {
  return (
    <div className={props.className}>
      <div className='card-icon'>{props?.icon}</div>
      {typeof props.cover !== 'string' && (
        <div className='card-cover' onClick={props?.onClick}>
          {props.cover}
        </div>
      )}
      {typeof props.cover === 'string' && <div className='card-cover' onClick={props?.onClick} />}
      <div className='card-body'>{props.children}</div>
    </div>
  );
};

export default styled(AdaptiveCard)`
  cursor: pointer;
  transition: ${({ theme }) => theme.motionDurationMid};
  transform: scale(0.99);
  &:hover {
    transform: scale(1);
  }

  .ant-skeleton {
    background: ${({ theme }) => theme.palette.gray[9]};
    border-radius: ${({ theme }) => theme.borderRadius}px;
  }

  .card-icon {
    position: absolute;
    font-size: 32px;
    color: white;
    z-index: 99;
    top: 0px;
    left: 8px;
  }

  .card-cover {
    position: relative;
    height: 0;
    background: ${({ theme }) => theme.palette.gray[9]};
    border-radius: ${({ theme }) => theme.borderRadius}px;
    padding-bottom: ${props => props.size};
    background-image: url(${props => (typeof props.cover === 'string' ? props.cover : '')});
    background-size: cover;

    .ant-skeleton-image {
      top: 0;
      min-width: 100%;
      min-height: 100%;
      position: absolute;
    }
  }

  .card-body {
    cursor: default;
    margin-top: ${({ theme }) => theme.space.spacing(4)};
    > h4 {
      margin-bottom: 0;
      color: ${({ theme }) => theme.colorTextSecondary};
    }
  }
`;
